import React from "react";

export const mergeCommodities = (crops) => {
  if (!crops || !Array.isArray(crops)) return [];

  const uniqueCrops = new Map();

  crops.forEach((crop) => {
    let baseName = crop.name.split("(")[0].trim();

    if (!uniqueCrops.has(baseName)) {
      uniqueCrops.set(baseName, {
        id: crop.id,
        name: baseName,
      });
    }
  });

  return Array.from(uniqueCrops.values());
};

export const formatDateForApi = (date) => {
  if (!date) return null;
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const formatDateTimeForApi = (date) => {
  if (!date) return null;
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day} 00:00:00`;
};

export const getSelectedIds = (selectedObject) => {
  if (!selectedObject) return [];
  return Object.keys(selectedObject).filter((id) => selectedObject[id]);
};

export const renderCommonTestsRow = (headings, item, isSelected) => {
  return headings.map(([key]) => (
    <td key={key} className="align-middle no-line border-0">
      {item[key]}
    </td>
  ));
};

export const createSelectionMap = (array) => {
  if (!array || !Array.isArray(array)) return {};

  const map = {};
  array.forEach((item) => {
    if (item && item.id) {
      map[item.id] = true;
    }
  });
  return map;
};

export const transformToApiPayload = (
  formValues,
  screens,
  commodities,
  user
) => {
  const selectedScreenIds = getSelectedIds(formValues.selectedScreens);
  const selectedScreens = screens
    .filter((screen) => selectedScreenIds.includes(screen.id))
    .map((screen) => screen.code);

  const selectedCommodityIds = getSelectedIds(formValues.selectedCommodities);
  const selectedCommodities = commodities
    .filter((commodity) => selectedCommodityIds.includes(commodity.id))
    .map((commodity) => commodity.name);

  const startDate = formatDateTimeForApi(formValues.start_date);
  const endDate = formatDateTimeForApi(formValues.end_date);

  const percentageValue =
    formValues.percentageCriteria !== undefined &&
    formValues.percentageCriteria !== null &&
    formValues.percentageCriteria !== ""
      ? parseFloat(formValues.percentageCriteria)
      : null;

  const excludePostCodes = Array.isArray(formValues.excludePostCodes)
    ? formValues.excludePostCodes
    : [];

  const payload = {
    email: user.email,
    detection_percent: percentageValue,
    query_filter: {
      "test.code": selectedScreens,
    },
    crops: selectedCommodities,
    period_start: startDate,
    period_end: endDate,
    exclude_postcodes: excludePostCodes,
  };

  if (formValues.excludeChallenge) {
    payload.query_filter.is_challenging = false;
  }

  if (formValues.excludeImport) {
    payload.is_overseas = false;
  }

  return payload;
};
